import { materialSwatchComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { adminDomainBuilder, adminInvariantBuilder, attachAdminComponent } from './__generated/admin-implementation.js';
import { CabinetWoodTextureMaterials, CountertopWoodTextureMaterials } from './__generated/admin-model/index.js';
import { generatedConfiguratorBuilder } from './__generated/configurator-builder.js';
import { domainBuilder, invariantBuilder } from './__generated/implementation.js';
import { migrateAdmin } from './admin-migrations/index.js';
import { adminCustomExpressions } from './implementations/admin-expressions.js';
import { entityExpressions, entityInvariants } from './implementations/expressions.js';
import { migrate } from './migrations/index.js';
import { resources } from './resources.js';
const adminViolationExpressions = adminInvariantBuilder.buildViolationExpressions();
export const adminDomainFactory = adminDomainBuilder.withExpressions(adminViolationExpressions).withExpressions(adminCustomExpressions).withMigrate(migrateAdmin).build();
const violationExpressions = invariantBuilder.withInvariants(entityInvariants).buildViolationExpressions();
const createDomain = domainBuilder.withExpressions(violationExpressions).withExpressions(entityExpressions).withMigrate(migrate).build();
const cabinetWoodTextureMaterialComponents = [
    attachAdminComponent.withComponent(materialSwatchComponent, 'woodTexture', true).withEntity('CabinetWoodTextureMaterial').attach(memoEval((self)=>[
            self.materialName,
            self.$woodSwatches
        ], (materialName, $woodSwatches)=>({
            selectedSwatchKey: materialName,
            swatches: $woodSwatches
        })), (state)=>{
        CabinetWoodTextureMaterials.assert(state.selectedSwatchKey);
        return {
            materialName: state.selectedSwatchKey
        };
    })
];
const countertopWoodTextureMaterialComponents = [
    attachAdminComponent.withComponent(materialSwatchComponent, 'woodTexture', true).withEntity('CountertopWoodTextureMaterial').attach(memoEval((self)=>[
            self.materialName,
            self.$woodSwatches
        ], (materialName, $woodSwatches)=>({
            selectedSwatchKey: materialName,
            swatches: $woodSwatches
        })), (state)=>{
        CountertopWoodTextureMaterials.assert(state.selectedSwatchKey);
        return {
            materialName: state.selectedSwatchKey
        };
    })
];
export const configuratorBuilder = generatedConfiguratorBuilder.withAdminComponentOptics(countertopWoodTextureMaterialComponents).withAdminComponentOptics(cabinetWoodTextureMaterialComponents).withDomainFactory(createDomain).withAdminDomainFactory(adminDomainFactory).withResources(resources);
export * as ApplicationTypes from './__generated/application-types.js';
export * as EnhancedDomain from './__generated/enhanced-model.js';
export * as Model from './__generated/model/index.js';
export * as AdminEnhancedDomain from './__generated/admin-enhanced-model.js';
export * as AdminModel from './__generated/admin-model/index.js';
export { floorTextureSwatches, getFloorTextureUrl, getFloorNormalMapUrl, getFloorRoughnessMapUrl, getFloorTileSize, getFloorColor, getFloorOpacity } from './data/floor-textures.js';
export { createPresets } from './__generated/presets.js';
export { createAdminPresets, generatedAdminPresets } from './__generated/admin-presets.js';
export { attachComponent, createRecipe } from './__generated/implementation.js';
export { attachAdminComponent, createAdminRecipe } from './__generated/admin-implementation.js';
export { mapPublishedRevisionDataHandler } from './handlers/map-published-revision-data.js';

//# sourceMappingURL=index.js.map